import React, { Component } from 'react';

import { getRegionByCode } from '@luxuryescapes/lib-regions';

class Flag extends Component {
  getRegionName = () => {
    return getRegionByCode(this.props.region);
  };

  render() {
    const icon = this.props.region === 'world' ? 'flag-icon-un' : 'flag-icon-' + this.props.region.toLowerCase();
    return <span title={this.getRegionName()?.name} className={'flag-icon ' + icon} style={this.props.style} />;
  }
}

export default Flag;
